(function($) {

	$.fn.msxitabs = function(options) {
		// build main options before element iteration
		var opts = $.extend(true, {}, $.fn.msxitabs.defaults, options);

		return this.each(function(i) {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            if($this.children('.tabs-header').size()==1) {
                $this.addClass('panel');
                $this.children('.tabs-header').each(function(){
                    var $tabsHeader = $(this);
                    $tabsHeader.addClass('panel-header');
                });
                var tabId;
                $this.children('.panel').each(function(){
                    var $panel = $(this);
                    if($panel.attr('id')) {
                        tabId = $panel.attr('id');
                    }
                    else {
                        tabId = 'tab-'+i+'-'+0;
                    }
                    $panel.replaceWith($panel.children('.panel-content').attr('id', tabId));
                });
                var selected = -1;
                $this.find('.tabs-header li.selected').each(function(){
                    selected = $(this).index();
                    $(this).children('a').attr('href', '#'+tabId);
                });

                $this.tabs($.extend(true, eOpts['tabs'], {
                    active: selected,
                    beforeActivate: function( e, ui )
                    {
                        // Follow URLs rather than using AJAX
                        var url = $(ui.newTab).find('a').attr('href');
                        if( url ) {
                            location.href = url;
                            return false;
                        }
                        return true;
                    }
                }));
            }
            // Now that a tab may use AJAX loading must initialise even if single tab otherwise AJAX href is not configured.
            if($this.children('.panel:not(.tabs-footer)').size()>0) {

                var tabsId;
                if($this.attr('id')) {
                    tabsId = $this.attr('id');
                }
                else {
                    tabsId = 'tabs-'+i;
                }

                // ul.panel-header to contain tab links
                var ul = $('<ul/>').addClass('panel-header');
                $this.addClass('panel').attr('id', tabsId);

                $this.children('.panel:not(.tabs-footer)').each(function(j){
                    var $panel = $(this);
                    var tabId;
                    if($panel.attr('id')) {
                        tabId = $panel.attr('id');
                    }
                    else {
                        tabId = 'tab-'+i+'-'+j;
                    }
                    // Use link from panel if there is one (loaded using AJAX) otherwise use the ID of the tab
                    var href;
                    if($panel.data('href')) {
                        href = $panel.data('href');
                    }
                    else {
                        href = '#'+tabId;
                    }
                    var panelHeaderText = $panel.children('.panel-header').find('h2').html();
                    // Use tabId for anchor link
                    var a = $('<a/>').attr('href', href);
                    a.attr('id', tabId + '-anchor');
                    var li = $('<li/>').attr('aria-controls', tabId);
                    li.attr('id', tabId + '-tab');
                    ul.append(li.append(a.html(panelHeaderText)));
                    // Add an id to the panel-content to be reference by the tab link and replace original .panel and .panel-header
                    $panel.replaceWith($panel.children('.panel-content').attr('id', tabId));
                });
                $this.prepend(ul);

                if(eOpts['sticky-tab']) {
                    var currentTab = $.cookies.get(tabsId + '-current-tab');
                    // Only use sticky-tab if URL does not contain a fragment
                    var url = window.location.href;
                    if(currentTab && !isNaN(currentTab) && (url.search("#") < 0)) {
                        eOpts['tabs']['active'] = currentTab;
                    }
                }

                if($this.find('.tabs-footer').size()>0) {
                    $this.addClass('tabs-with-footer');
                }

                $this.tabs(eOpts['tabs']);

                validateTabs($this);

                $this.find('.panel-legend').each(function(){
                    var legendWidth = $this.find('.panel-legend').width();
                    $this.find('.panel-header').css('padding-right', legendWidth-5);
                });

                balance($this.find('ul.ui-tabs-nav'));
            }
        });
	};
    
	//
	// plugin defaults
	//
	$.fn.msxitabs.defaults = {
            'sticky-tab':true, // remember current tab
            tabs: {
                fxSlide: false,
                fxFade: false,
                beforeActivate: function( e, ui )
                {
                    // JQuery tabs shows "Loading..." while the tab is loading. We don't want this but the only way to disable is by restoring the correct text
                    if (ui.newTab.find('a').attr('href').substring(0, 1)  != '#') {
                        ui.newTab.data('oldValue', ui.newTab.find('a').clone(true));
                    }
                    var tabsId = $(ui.newTab).closest('.panel').attr('id');
                    $.cookies.set(tabsId + '-current-tab', ui.newTab.index());

                },
                activate: function( e, ui )
                {
                    var oldValue = ui.newTab.data('oldValue');
                    if (oldValue) {
                        ui.newTab.empty().append(oldValue);
                        ui.newTab.data('oldValue', undefined);
                    }
                    $(ui.newPanel).find('table').has('col.trim').msxiTableTrimmer();
                    $(window).trigger('updateStalker');
                    showTabValidation($(ui.newPanel));
                },
                beforeLoad: function( event, ui ) {
                    // Tabs with remote content should only be loaded once
                    if ( ui.tab.data( "loaded" ) ) {
                        event.preventDefault();
                        return;
                    }
                    // Hasn't loaded yet but if the user switches tabs during load we want to make sure it doesn't start loading again
                    ui.tab.data( "loaded", true );

                    $(ui.panel).addClass('panel-content-loading');

                    var $spinner = $('<div class="loading-spinner"/>').appendTo($(ui.panel));
                    var spinner = Spinners.create($($spinner), $.fn.msxitabs.defaults.spinner).play();

                    ui.jqXHR.success(function() {
                        spinner.remove();
                        $spinner.remove();
                    });
                },
                load: function( event, ui ) {

                    $(ui.panel).removeClass('panel-content-loading');
                    
                    $(ui.panel).msxiinit();

                    initTabPageNavigation($(ui.panel));
                    initTabForm($(ui.panel));
                }
            },
            spinner: {
                radius: 8,
                height: 10,
                width: 3,
                dashes: 12,
                opacity: 1,
                padding: 3,
                rotation: 1000,
                color: '#666'
            }
	};

    function initTabPageNavigation($uiPanel)
    {
        $uiPanel.on('click', '.page-navigation a, th.sortable, form a.button', function(){
            var href;
            if ($(this).is('a')) {
                href = $(this).attr('href');
            } else {
                href = $(this).find("a").attr('href');
            }
            if (href) {
                $('<div class="loading-spinner-overlay" />').appendTo($uiPanel);
                var $spinner = $('<div class="loading-spinner"/>').appendTo($uiPanel);
                var spinner = Spinners.create($spinner, $.fn.msxitabs.defaults.spinner).play();
                $uiPanel.load(href, function () {
                    $uiPanel.msxiinit();
                    spinner.remove();
                    $spinner.remove();
                    
                    $uiPanel.trigger('tab-loaded');
                });
                return false;
            }
        });
    }
    
    function initTabForm($uiPanel) {
        $uiPanel.on('submit', 'form', function() {
            var $enabledSubmits = $uiPanel.find(".ui-button:submit:enabled").button('disable');
            var $form = $(this);

            $('<div class="loading-spinner-overlay" />').appendTo($uiPanel);
            var $spinner = $('<div class="loading-spinner"/>').appendTo($uiPanel);
            var spinner = Spinners.create($spinner, $.fn.msxitabs.defaults.spinner).play();

            $.ajax({
                type: $form.attr("method"),
                url: $form.attr("action"),
                data: $form.serialize(),
                success: function(data)
                {
                    $uiPanel.html(data);

                    $uiPanel.msxiinit();
                    spinner.remove();
                    $spinner.remove();

                    $uiPanel.trigger('tab-loaded');

                    try {
                        $enabledSubmits.filter('.ui-button').button('enable');
                    } catch (e) {
                        // Using try block because for unknown reason this sometimes fails with:
                        // "Uncaught Error: cannot call methods on button prior to initialization; attempted to call method 'enable'"
                    }
                }
            });
            return false;
        });
    }

    /**
     * Balancing rules:
     * 1. Each <li> is trimmed to take no more than its fair proportion of space. i.e. if there are 4 <li> none can be larger than 25%.
     * 2. Any remaining space is allocated evenly amongst remaining <li>.
     */
    function balance($ul) {
        var maxWidth = $ul.width();
        var $li = $ul.find('li');
        var currentWidth = 0;
        $li.each(function(){
            currentWidth = currentWidth + $(this).outerWidth(true);
        });
        if (currentWidth > maxWidth) {
            // The size <li> get trimmed to
            var trimmedWidth = parseInt(maxWidth / $li.size(), 10);
            // Variable to keep track if how much space we have allocated
            var remainingWidth = maxWidth;
            var trimmedWidthDiff = -1;
            // 1.
            $li.each(function () {
                var $li = $(this);
                var $a = $li.find('a');
                if (!$li.data('original-width')) {
                    // Cache the original width
                    $li.data('original-width', $a.width());
                    $li.data('original-outer-width', Math.ceil($li.outerWidth(true)));
                }
                var originalWidth = $li.data('original-width');
                var originalOuterWidth = $li.data('original-outer-width');
                var padding = originalOuterWidth - originalWidth;
                var width = originalWidth;
                if (originalOuterWidth > Math.min(trimmedWidth, remainingWidth)) {
                    // Adding the trimmed class changes the size of the $li so we need to take that into account
                    if(trimmedWidthDiff == -1) {
                        var beforeWidth = $li.outerWidth(true);
                        $li.addClass('trimmed');
                        trimmedWidthDiff = beforeWidth - $li.outerWidth(true);
                    }
                    $li.addClass('trimmed');
                    $li.attr('title', $li.text());
                    width = Math.min(trimmedWidth, remainingWidth) - padding + trimmedWidthDiff;
                }
                $a.css('width', width + 'px');
                var outerWidth = Math.ceil($li.outerWidth(true));
                remainingWidth = remainingWidth - outerWidth;
            });
            // 2.
            while (remainingWidth > 0 && $ul.find('li.trimmed').size() > 0) {
                var $trimmedLi = $ul.find('li.trimmed');
                var remainingShare = parseInt(remainingWidth / $trimmedLi.size(), 10);
                if (remainingShare == 0) {
                    // There are more trimmed <li> than remaining pixels, so we add 1px to each <li> until we run out of space.
                    remainingShare = 1;
                }
                $trimmedLi.each(function () {
                    if (remainingWidth > 0) {
                        var $li = $(this);
                        remainingWidth = increaseTrimmedLi($li, remainingShare, remainingWidth, trimmedWidthDiff);
                    }
                });
            }
        }
    }

    function increaseTrimmedLi($li, amount, remainingWidth, trimmedWidthDiff) {
        var $a = $li.find('a');
        var width = $a.width() - trimmedWidthDiff;
        var maxWidth = width + amount;
        var originalWidth = $li.data('original-width');
        var outerWidth = Math.ceil($li.outerWidth(true));
        if (originalWidth > width) {
            remainingWidth = remainingWidth + outerWidth;
            width = Math.min(originalWidth, maxWidth);
            if (width == originalWidth) {
                $li.removeClass('trimmed');
                $li.removeAttr('title');
            }
            else {
                width = width + trimmedWidthDiff;
            }
            $a.css('width', width + 'px');
            outerWidth = Math.ceil($li.outerWidth(true));
            remainingWidth = remainingWidth - outerWidth;
        }
        return remainingWidth;
    }

    /**
     * Listen to invalid event on input fields and mark the tab invalid
     */
    function validateTabs($tabs) {
        if (hasFormValidation()) {
            $tabs.find(':input').bind('invalid', function (e) {
                var $input = $(this);
                if ($input.is(':not(:focusable)')) {
                    // Prevent browser attempting to display validation message on fields that are not visible
                    // Chrome throws a Javascript error
                    // Firefox and IE display the message in the wrong place
                    e.preventDefault();
                }
                var $tabPanel = $input.parents('.ui-tabs-panel:first');
                var id = $tabPanel.attr('id');
                var $tabsPanel = $tabPanel.parents('.ui-tabs:first');
                var $a = $tabsPanel.find('a[href=#' + id + ']');
                if ($a.find('.tab-error').size() == 0) {
                    $a.wrapInner($('<div class="tab-error"></div>'));
                    $a.find('.tab-error').msxiicon({icon: 'ui-icon-alert'});
                }
            });
        }
    }

    /**
     * When the user switches tabs display any validation messages
     */
    function showTabValidation(tabPanel) {
        if (hasFormValidation()) {
            var $tabPanel = $(tabPanel);
            var id = $tabPanel.attr('id');
            var $tabsPanel = $tabPanel.parents('.ui-tabs:first');
            var $a = $tabsPanel.find('a[href=#' + id + ']');
            if ($a.find('.tab-error').size() > 0) {
                var $form = $tabsPanel.parents('form');
                // the only way to display the validation messages is to trigger submission of the form
                // dummy hidden required field to prevent the form actually submitting
                $form.append($('<input name="dummy" class="dummy" type="text" required="true" />'));
                $form.find(':submit').click();
                $form.find('.dummy').remove();
            }
        }
    }

})(jQuery);